$(document).on('click', '.js-event-stop-propagation', function(e) {
    e.stopPropagation();
    // e.preventDefault();
});









